import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './reducers';

// Configure persistence
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'] // Only persist the user reducer
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// For Redux DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create store with persisted reducer
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);

// Create persistor
const persistor = persistStore(store);

export { store, persistor }; 